import { CrudModel } from "./_crud";

export class BlogPostCategoryAppModel extends CrudModel {
	constructor() {
		super("app/blog_post_category");
	}
}

export default new BlogPostCategoryAppModel();
